import { AppEnv } from './types';

export const BLOG_LABEL = 'Pickleball Hub';
export const MEME_SLUG = 'meme';
export const MEME_SUBCATEGORY_SLUG = 'memes';

export const PICKLEBALL_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/PB-gray.svg`;
export const CLUBS_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/PC-gray.svg`;
export const LEAGUES_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/PL-gray.svg`;
export const TOURNAMENT_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/PT-gray.svg`;
export const TEAM_LEAGUES_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/PTL-gray.svg`;
export const APR_PLACEHOLDER_IMAGE = `https://images.pickleball.com/global/APR-gray.svg`;

export const PICKLEBALL_CONTACT_US_URL = 'https://pickleball.com/docs/en/';

/** Advertise with us URL per environment */
export const ADVERTISE_WITH_US_URLS: Record<AppEnv, string> = {
	dev: 'https://contact.pickleballdev.net/advertise',
	test: 'https://contact.pickleballtest.net/advertise',
	prod: 'https://contact.pickleball.com/advertise'
};
